module.exports = __webpack_public_path__ + "img/hands.84a0f614.svg";